module.exports = __webpack_public_path__ + "img/male.ada87b39.gif";